import { DateTimeFormatter } from "@js-joda/core";
import { Locale } from "@js-joda/locale_en-us";
import BloodGlucoseClassification from "../../../../model/BloodGlucoseClassification";
import { BloodGlucoseReading } from "../../../../model/BloodGlucoseReading";
import cn from "../../../../util/cn";
import { Cell, CellProps } from "../../Cell";
import NewDataTooltipIndicator from "../../NewDataTooltipIndicator";

type OverviewCellProps = Omit<CellProps, "children"> & {
  readings: BloodGlucoseReading[];
  status: "default" | "new" | "disabled";
};

const dateTimeFormatter = DateTimeFormatter.ofPattern("MM/dd/yyyy h:mm a").withLocale(Locale.US);

const MeasurementLogCell = ({ readings, status, className, ...otherProps }: OverviewCellProps) => {
  const isNew = status === "new";
  const isDisabled = status === "disabled";

  return (
    <Cell
      className={cn(
        "relative flex flex-col items-center justify-center p-2",
        isDisabled ? "cursor-default" : "cursor-pointer",
        className
      )}
      outline
      {...otherProps}
    >
      {isNew && (
        <div className="absolute right-2 top-2">
          <NewDataTooltipIndicator />
        </div>
      )}
      {isDisabled
        ? null
        : readings.length === 0
          ? "-"
          : readings.map((reading) => (
              <div
                key={`reading-${reading.id}`}
                title={dateTimeFormatter.format(reading.dateTime.toLocalDateTime())}
                className={cn("font-semibold", textColorForClassification(reading.classification))}
              >
                {reading.bloodGlucoseInMilligramsPerDeciliter}
              </div>
            ))}
    </Cell>
  );
};

const textColorForClassification = (classification: BloodGlucoseClassification) => {
  switch (classification) {
    case "critical-low":
    case "elevated":
    case "low":
      return "text-measurement-text-warning";
    case "emergency-low":
    case "critical-high":
      return "text-measurement-text-emergency";
    default:
      return "text-measurement-text-acceptable";
  }
};

export default MeasurementLogCell;
